import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBK1pKMvitoarRgI24N0yVpMAWPSprrIBE",
  authDomain: "maria-penha-virtual.firebaseapp.com",
  databaseURL: "https://maria-penha-virtual-default-rtdb.firebaseio.com",
  projectId: "maria-penha-virtual",
  storageBucket: "maria-penha-virtual.appspot.com",
  messagingSenderId: "881350879144",
  appId: "1:881350879144:web:16852e71d2c3e9c6bf1f9d",
  measurementId: "G-7E03H10VVD",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const functions = getFunctions(app);
const auth = getAuth(app);

export { app, analytics, functions, auth };
